import { useI18n } from '@/i18n/i18n-context'
import { Card } from '@/ui/card'

/**
 * A scan that produced nothing, twice, after the patient had already been offered one retry.
 *
 * **It says what happened and who is dealing with it, and asks for nothing back.** The patient has
 * held a phone to their face twice for a fault they can neither see nor fix, so a third invitation
 * would be this page asking them to keep paying for it. What is left that is worth saying is that
 * somebody knows - an unexplained failure a patient is told to forget about is worse than one they
 * are told is being handled.
 *
 * It must NOT say what the complete screen says. That one promises a measurement was taken and sent,
 * and here nothing was.
 */
export function ThankedScreen() {
  const { t } = useI18n()
  return (
    <Card className="flex flex-col gap-3 text-center">
      <h1 className="text-lg font-semibold text-slate-900">{t('scanFailed')}</h1>
      <p className="text-sm text-slate-600">{t('careTeamNotified')}</p>
      <p className="text-sm text-slate-500">{t('scanCompleteClose')}</p>
    </Card>
  )
}
